export const formatDate = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  return isNaN(dt) ? "" : dt.toLocaleDateString();
};

export const imgOrPlaceholder = (src, w = 480, h = 320) =>
  src || `https://via.placeholder.com/${w}x${h}.png?text=${w}x${h}`;
